<template>
  <section class="bloc-list">
    <div class="bloc-list__wrapper">
      <h2 class="bloc-list__title" v-html="content.title"></h2>
      <div class="bloc-list__text-wrapper">
        <div class="text" v-html="content.text"></div>
      </div>
      <ul class="bloc-list__list">
        <li v-for="(item, i) in content.items" :key="i" v-html="item"></li>
      </ul>
    </div>
  </section>
</template>

<script>
export default {
  name: 'List',
  props: {
    content: {
      type: Object,
      required: true
    },
  },
}
</script>

<style lang="scss">
  .bloc-list {
    width: 100vw;
    background: $th-cherry;
    padding: 70px 0;
    overflow: hidden;
    position: relative;

    &__wrapper {
      width: grid_m(5, 4);
      margin: 0 auto;

      @include media($from: small) {
        width: grid(8, 7);
      }
    }

    &__img-quater,
    &__img-lemon {
      position: absolute;
    }

    &__img-quater {
      top: 0;
      left: 0;
      width: 360px;
      opacity: 0.4;
      transform: translateX(calc(-50% - 14px));
    }

    &__img-lemon {
      bottom: 30px;
      right: 0;
      width: 320px;
      opacity: 0.34;
      transform:  translateX(40%) rotate(30deg);
    }

    &__title {
      position: relative;
      font-size: 21px;
      font-family: "Gotham Book";
      color: $th-grey;
      text-align: center;
      display: block;
      line-height: 1.65;
      text-transform: uppercase;

      .text-yellow {
        color: $th-yellow;
      }
    }

     &__text-wrapper {
      position: relative;
      margin-top: 30px;
      display: flex;
      justify-content: center;
      margin: 30px auto 0;


      .text {
        position: relative;
        line-height: 1.5;
        font-size: 18px;
        font-family: "Georgia";
        color: $th-grey;
        display: inline-block;
        text-indent: 15px;

         @include media($from: large) {
          left: -8px;
        }

         &::before {
          content: "";
          width: 5px;
          height: 5px;
          background: $th-yellow;
          position: absolute;
          left: 0;
          top: 13px;
        }
      }
    }

    &__list {
      position: relative;
      font-size: 18px;
      font-family: "Georgia";
      color: $th-grey;
      text-align: left;
      display: block;
      line-height: 1.5;
      margin-top: 15px;

      @include media($from: small) {
        columns: 2;
        column-gap: 78px;
        margin-top: 30px;
      }

      li {
        text-indent: 15px;
        margin: 14px 0;
        position: relative;

        @include media($from: small) {
          margin-bottom: 14px;
          margin-top: 0;
        }

        &::before {
          content: "";
          width: 5px;
          height: 5px;
          background: $th-yellow;
          position: absolute;
          left: 0;
          top: 13px;
        }

        sup {
          font-size: 12px;
        }
      }
    }
  }
</style>
